import { Pipe, PipeTransform } from '@angular/core';
import { interpolateString } from '../../../../helpers/utils';

@Pipe({
  name: 'interpolateUrl'
})
export class ParseUrlPipe implements PipeTransform {
  constructor() {}

  transform(value: string, url: string): any {
    if (!url) {
      return value;
    }
    return interpolateString(url, {
      id: value
    });
  }
}
